import { QuestionBase } from './question-base.model';

export class VideoViewerQuestion extends QuestionBase<string> {
    controlType = 'kx-video';
    video_path: any;
    video_type: any;
    visible: string;
    constructor(options: {} = {}) {
        super(options);
        this.video_path = options['video_path'];
        this.video_type = options['video_type'];
        this.visible = (options['visible'] == undefined) ? true : options['visible'];
    }
}